import { supabase } from '../../../integrations/supabase/client';

const EXTRACTION_API_URL = import.meta.env.VITE_EXTRACTION_API_URL || 'https://extraction.ciobaa.easypanel.host';
const EXTRACTION_API_SECRET = import.meta.env.VITE_EXTRACTION_API_SECRET || '';

export interface ExtractionProgress {
  id: string;
  status: string;
  total_chats: number;
  processed_chats: number;
  media_total: number;
  media_processed: number;
  error_message?: string | null;
  started_at?: string | null;
  completed_at?: string | null;
}

export async function triggerExtraction(params: {
  userId: string;
  agentId: string;
  sessionName: string;
}): Promise<{ extraction_id: string }> {
  const response = await fetch(`${EXTRACTION_API_URL}/api/extract`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${EXTRACTION_API_SECRET}`,
    },
    body: JSON.stringify({
      user_id: params.userId,
      agent_id: params.agentId,
      session_name: params.sessionName,
      max_chats: 500,
      max_messages_per_chat: 100,
    }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(error.error || `Error: ${response.status}`);
  }

  return response.json();
}

export function subscribeToExtraction(
  extractionId: string,
  onProgress: (data: ExtractionProgress) => void
): () => void {
  const channel = supabase
    .channel(`extraction-${extractionId}`)
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'chat_extractions',
        filter: `id=eq.${extractionId}`,
      },
      (payload) => {
        onProgress(payload.new as ExtractionProgress);
      }
    )
    .subscribe();

  return () => {
    supabase.removeChannel(channel);
  };
}

export async function getLatestExtraction(agentId: string): Promise<ExtractionProgress | null> {
  const { data, error } = await supabase
    .from('chat_extractions')
    .select('*')
    .eq('agent_id', agentId)
    .order('created_at', { ascending: false })
    .limit(1)
    .maybeSingle();

  if (error) {
    console.error('Error fetching extraction:', error);
    return null;
  }

  return data;
}
